import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
//import { Configuration } from 'src/app/Utilities/configurations';
//var Configuration = require('src/assets/app-config.json');
import { IAttributes } from 'src/app/models/IAttributes';
import { IPostSurgical } from 'src/app/models/IPostSurgicial';
import { IAssessment } from 'src/app/models/IAssessment';
import { IEncounterData } from 'src/app/models/IEncounterData';
import { IUserDetails } from 'src/app/models/IUsersDetails';
import { IORRecord, IOperatingProcedure } from 'src/app/models/IORRecord';
import { configuration } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })

export class PostSurgicalClinicService {

  constructor(private http: HttpClient) { }

  //   getMasterData(): Observable<IAttributes[]> {
  //     return this.http.get<IAttributes[]>(`${configuration.clinicapiUrl + 'Master/ASCMasterData'}?loggedUser=admin`);
  //   }

  getPostSurgicalDetails(encId: string, userId: string): Observable<IPostSurgical> {
    return this.http.get<IPostSurgical>(`${configuration.clinicapiUrl + 'Encounter/GetPostSurgical'}?userid=${userId}&&encid=${encId}`);
  }
  // savePostSurgical(PostSurgicalInfo: IPostSurgical): Observable<IPostSurgical> {
  //   return this.http.post<IPostSurgical>(`${configuration.clinicapiUrl + 'Encounter/SetPostSurgical'}`, PostSurgicalInfo, {
  //     // headers: new HttpHeaders({ 'content-Type': 'application/json' })
  //   });
  // }
  savePostSurgical(PostSurgicalInfo: IPostSurgical): Observable<IPostSurgical> {
    const posteddata={
          inputdata:JSON.stringify(PostSurgicalInfo)
        } 
        return this.http.post<IPostSurgical>(`${configuration.clinicapiUrl + 'Encounter/SetPostSurgical'}`, posteddata, {
          // headers: new HttpHeaders({ 'content-Type': 'application/json' })
        });
      }
  signOffPostSurgical(PostFollowInfo: IPostSurgical): Observable<IPostSurgical> {
    return this.http.post<IPostSurgical>(`${configuration.clinicapiUrl + 'Encounter/SetSignOffPostSurgical'}`, PostFollowInfo, {
    });
  }

  getFluiddrpdetails(encId: string): Observable<string> {
    return this.http.get<string>(`${configuration.clinicapiUrl + 'Encounter/IVfluidDrpData'}?encid=${encId}`);
  }

  getAnestesiadrpdetails(encId: string): Observable<IAttributes[]> {
    return this.http.get<IAttributes[]>(`${configuration.clinicapiUrl + 'Encounter/AnestesiaDrpData'}?encid=${encId}`);
  }


  // getProceduredetails(encId: string): Observable<IOperatingProcedure[]> {
  //   return this.http.get<IOperatingProcedure[]>(`${configuration.clinicapiUrl + 'Encounter/GetProcedureValues'}?encid=${encId}`);
  // }
  DeleteSelectMedicationInfo(Id: number): Observable<number> {
    return this.http.delete<number>(`${configuration.clinicapiUrl + 'Encounter/PostSurgicalMedicationdelete'}?id=${Id}&&userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  DeleteSelectVitalsInfo(Id: number): Observable<number> {
    return this.http.delete<number>(`${configuration.clinicapiUrl + 'Encounter/PostSurgicalVitalSign'}?id=${Id}&&userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }


  // Add staff details
  addStaffDetails(usersData: IUserDetails[], type: string): Observable<string> {
    const posteddata={
      inputdata:JSON.stringify(usersData)
    } 
    return this.http.post<string>(`${configuration.clinicapiUrl + 'Encounter/EncounterStaff'}?staffType=${type}`, posteddata, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  // Delete staff details
  deleteStaffDetails(usersData: IUserDetails[], type: string): Observable<string> {
    const posteddata={
      inputdata:JSON.stringify(usersData)
    } 
    return this.http.put<string>(`${configuration.clinicapiUrl + 'Encounter/EncounterStaff'}?type=${type}`, posteddata, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });
  }

  getServicebyEncounterId(encId: string): Observable<string> {
    return this.http.get<string>(`${configuration.clinicapiUrl + 'Encounter/GetLocationByEncId'}?encId=${encId}&&userid=${encodeURIComponent(sessionStorage.getItem("userId")).toString()}`);
  }
  updateLockStatus(encounterId: string, isSignedOff: boolean, modified: string): Observable<string> {
    return this.http.put<string>(`${configuration.clinicapiUrl + 'Encounter/PostSurgicalUpdateLock'}?encounterId=${encounterId}&&isSignedOff=${isSignedOff}&&modifiedBy=${modified}`, {
      headers: new HttpHeaders({ 'content-Type': 'application/json' })
    });

  }
}
